module.exports = __webpack_public_path__ + "media/images/claim_profile/backup-0f1e8bf72c1775a0f955217c2f86b362.png";